import React from 'react'
import { Modal } from 'react-bootstrap'
import cancelIcon from '../images/remove.png'

const ImageErrorModal = ({show,handleClose,ErrorMessage}) => {
  return (
    <Modal className="required-modal"
    show={show} onHide={handleClose} centered>
    <Modal.Body style={{display:'flex',justifyContent:'center',alignItems:'center',padding:"40px 20px"}}>
        <img src={cancelIcon} alt="" height={30} width={30}/>
        <div style={{color:"#dc2020",margin:0,marginLeft:'10px',fontSize:'18px'}}>{ErrorMessage}</div>
    </Modal.Body>
</Modal>
  )
}

export default ImageErrorModal
